import { render } from "./App.vue?vue&type=template&id=ef37434a"
const script = {}

import exportComponent from "/Users/markvi/www/buterin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__